import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { TextInput } from "../../../Components/Input/Input";
import { ButtonSave, ButtonClose } from "../../../Components/Button/Button";
import axios from "axios";
import { UrlApi, authorization } from "../../../UrlApi/UrlApi";
import Loading from "../../../Components/Loading/Loading";
import {
  AlertError,
  AlertSuccess,
  AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import SelectAutoComplete from "../../../Components/Input/Input";
import Box from "@mui/material/Box";
import { userData } from "../../../DataContext/DataContext";
import { useRecoilValue } from "recoil";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { InputAdornment, IconButton } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Grid from "@mui/material/Unstable_Grid2";

function AddUserData(props) {
  const user = useRecoilValue(userData);
  const [loading, setLoading] = useState(false);
  const [empCodeErr, setEmpCodeErr] = useState(false);
  const [empTitleIdErr, setEmpTitleIdErr] = useState(false);
  const [empFirstnameErr, setEmpFirstnameErr] = useState(false);
  const [empLastnameErr, setEmpLastnameErr] = useState(false);
  const [empNicknameErr, setEmpNicknameErr] = useState(false);
  const [empTelErr, setEmpTelErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [passWordErr, setPassWordErr] = useState(false);
  const [confirmPassWordErr, setConfirmPassWordErr] = useState(false);
  const [roleGroupErr, setRoleGroupErr] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [pageSize, setPageSize] = useState(50);

  const [empCode, setEmpCode] = useState("");
  const [empTitleId, setEmpTitleId] = useState("");
  const [empFirstname, setEmpFirstname] = useState("");
  const [empLastname, setEmpLastname] = useState("");
  const [empNickname, setEmpNickname] = useState("");
  const [empTel, setEmpTel] = useState("");
  const [titleName, setTitleName] = useState("");
  const [email, setEmail] = useState("");
  const [passWord, setPassWord] = useState("");
  const [confirmPassWord, setConfirmPassWord] = useState("");
  const [roleGroupId, setRoleGroupId] = useState("");
  const [roleGroupName, setRoleGroupName] = useState("");
  const [statusActive, setStatusActive] = useState(true);
  const [titleData, setTitleData] = useState([]);
  const [roleGroupData, setRoleGroupData] = useState([]);

  const onSubmit = async (event) => {
    event.preventDefault();
    if(email !== "" && email !== null || passWord !== "" && passWord !== null){
      if (!isValidEmail(email)) {
        setEmailErr(true);
        return false;
      } else {
        setEmailErr(false);
      }
    }
    if (props.empId === null) {
      if(passWord !== "" && passWord !== null || email !== "" && email !== null){
        if (!isValidPassword(passWord)) {
          setPassWordErr(true);
          return false;
        } else {
          setPassWordErr(false);
        }
      }
    }
    if (passWord !== confirmPassWord) {
      setConfirmPassWordErr(true);
      return false;
    } else {
      setConfirmPassWordErr(false);
    }
    if (empCode === "") {
      setEmpCodeErr(true);
      return false;
    } else {
      setEmpCodeErr(false);
    }
    if (empTitleId === "") {
      setEmpTitleIdErr(true);
      return false;
    } else {
      setEmpTitleIdErr(false);
    }
    if (empFirstname === "") {
      setEmpFirstnameErr(true);
      return false;
    } else {
      setEmpFirstnameErr(false);
    }
    if (empLastname === "") {
      setEmpLastnameErr(true);
      return false;
    } else {
      setEmpLastnameErr(false);
    }
    if (empNickname === "") {
      setEmpNicknameErr(true);
      return false;
    } else {
      setEmpNicknameErr(false);
    }
    if (empTel === "") {
      setEmpTelErr(true);
      return false;
    } else {
      setEmpTelErr(false);
    }
    if (roleGroupId === "") {
      setRoleGroupErr(true);
      return false;
    } else {
      setRoleGroupErr(false);
    }

    const body = {
      email,
      passWord,
      empCode,
      empTitleId,
      empFirstname,
      empLastname,
      empNickname,
      empTel,
      roleGroupId,
      statusActive,
      empId: props.empId,
    };

    if (props.empId === null) {
      setLoading(true);
      await axios
        .post(UrlApi + "save_user_data", body, authorization)
        .then((res) => {
          if (res.data.status === 1) {
            props.onCancel();
            AlertSuccess(res.data.message);
            setLoading(false);
          } else {
            AlertWarning(res.data.message);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    } else {
      setLoading(true);
      await axios
        .post(UrlApi + "update_user_data", body, authorization)
        .then((res) => {
          if (res.data.status === 1) {
            props.onCancel();
            AlertSuccess(res.data.message);
            setLoading(false);
          } else {
            AlertWarning(res.data.message);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }
  };

  const getData = async () => {
    if (props.empId !== null) {
      setLoading(true);
      await axios
        .post(
          UrlApi + "get_employee_data_for_edit",
          { empId: props.empId },
          authorization
        )
        .then((res) => {
          setEmail(res.data[0].user_name);
          setPassWord(res.data[0].pass_word);
          setConfirmPassWord(res.data[0].pass_word);
          setEmpCode(res.data[0].emp_code);
          setEmpTitleId(res.data[0].emp_title_id);
          setTitleName(res.data[0].emp_title_name);
          setEmpFirstname(res.data[0].emp_firstname);
          setEmpLastname(res.data[0].emp_lastname);
          setEmpNickname(res.data[0].emp_nickname);
          setEmpTel(res.data[0].emp_tel);
          setRoleGroupId(res.data[0].role_id);
          setRoleGroupName(res.data[0].role_name);
          setStatusActive(res.data[0].emp_default_active);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }
    setLoading(true);
    await axios
      .post(UrlApi + "get_title_data", {}, authorization)
      .then((res) => {
        setTitleData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });

    setLoading(true);
    await axios
      .post(UrlApi + "get_role_group_data", {}, authorization)
      .then((res) => {
        setRoleGroupData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  function isValidPassword(passWord) {
    const lower = new RegExp(/(?=.*[a-z])/);
    const upper = new RegExp(/(?=.*[A-Z])/);
    const number = new RegExp(/(?=.*[0-9])/);
    const special = new RegExp(/(?=.*[-_?!@#\$%/^&\*])/);
    const length = new RegExp(/(?=.{8,})/);
    const checkPassword = [
      lower.test(passWord),
      upper.test(passWord),
      number.test(passWord),
      special.test(passWord),
      length.test(passWord),
    ];
    return checkPassword.every((element) => element === true);
  }

  const marginLeft = {
    marginLeft: "9px",
  };

  const handleEnter = (event) => {
    const id = parseInt(event.target.id);
    const form = event.target.form;
    const index = [...form].indexOf(event.target);
    let next = 2;
    if (event.key === "Enter") {
      if (id === 10) {
        onSubmit(event);
        return false;
      }
      switch (id) {
        case 2:
          next = 3;
          break;
        case 3:
          next = 3;
          break;
        case 5:
          next = 4;
          break;     
        default:
          next = 2;
      }
      form.elements[index + next].focus();
      event.preventDefault();
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <Dialog
        open={props.open}
        maxWidth="1500"
        PaperProps={{ style: { borderRadius: 10 } }}
      >
        <Box component="form" noValidate onSubmit={onSubmit} sx={{ mt: 1 }}>
          <DialogTitle>
            <label>
              {props.empId === null
                ? "เพิ่มข้อมูลผู้ใช้งานระบบ"
                : "แก้ไขข้อมูลผู้ใช้งานระบบ"}
            </label>
          </DialogTitle>
          <DialogContent dividers="paper">
            <form>
              <table>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>Email</label>
                    {
                      <TextInput
                        autoFocus={true}
                        id="1"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          if (!isValidEmail(e.target.value) === true) {
                            setEmailErr(false);
                          }
                        }}
                        error={emailErr}
                        helperText={emailErr && "รูปแบบ Email ไม่ถูกต้อง"}
                        onKeyDown={handleEnter}
                        width="100%"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>รหัสผ่าน</label>
                    {
                      <TextInput
                        id="2"
                        disabled={props.empId !== null ? true : false}
                        value={passWord}
                        type={showPassword ? "text" : "password"}
                        onChange={(e) => {
                          setPassWord(e.target.value);
                          if (isValidPassword(e.target.value)) {
                            setPassWordErr(false);
                          }
                        }}
                        error={passWordErr}
                        helperText={
                          <label style={{ fontSize: "12px" }}>
                            รหัสผ่านต้องประกอบด้วยตัวอักษรพิมพ์เล็ก (a-z)
                            พิมพ์ใหญ่ (A-Z) <br />
                            ตัวเลข (0-9) อักขระพิเศษ เช่น (-_?!@#\$%/^&\*)
                            และมีความยาวอย่างน้อย 8 ตัวอักษร
                          </label>
                        }
                        onKeyDown={handleEnter}
                        width="100%"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>ยืนยันรหัสผ่าน</label>
                    {
                      <TextInput
                        id="3"
                        disabled={props.empId !== null ? true : false}
                        value={confirmPassWord}
                        type={showPasswordConfirm ? "text" : "password"}
                        onChange={(e) => {
                          setConfirmPassWord(e.target.value);
                          if (e.target.value === passWord) {
                            setConfirmPassWordErr(false);
                          }
                        }}
                        error={confirmPassWordErr}
                        helperText={confirmPassWordErr && "รหัสผ่านไม่ตรงกัน"}
                        onKeyDown={handleEnter}
                        width="100%"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() =>
                                setShowPasswordConfirm(!showPasswordConfirm)
                              }
                              edge="end"
                            >
                              {showPasswordConfirm ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>รหัสพนักงาน</label>
                    {
                      <TextInput
                        id="4"
                        value={empCode}
                        onChange={(e) => {
                          setEmpCode(e.target.value);
                          setEmpCodeErr(false);
                        }}
                        error={empCodeErr}
                        onKeyDown={handleEnter}
                        width="100%"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>คำนำหน้า</label>
                    {
                      <SelectAutoComplete
                        id="5"
                        options={titleData}
                        onChange={(value, valueText) => {
                          setTitleName(valueText);
                          setEmpTitleId(value);
                          setEmpTitleIdErr(false);
                        }}
                        value={titleName}
                        onInputChange={(event, newInputValue) => {}}
                        error={empTitleIdErr}
                        width="100%"
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label style={marginLeft}>ชื่อ</label>
                    {
                      <TextInput
                        id="6"
                        onChange={(e) => {
                          setEmpFirstname(e.target.value);
                          setEmpFirstnameErr(false);
                        }}
                        error={empFirstnameErr}
                        value={empFirstname}
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                  <td colspan="3">
                    <label style={marginLeft}>นามสกุล</label>
                    {
                      <TextInput
                        id="7"
                        onChange={(e) => {
                          setEmpLastname(e.target.value);
                          setEmpLastnameErr(false);
                        }}
                        error={empLastnameErr}
                        value={empLastname}
                        onKeyDown={handleEnter}
                        width="100%"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label style={marginLeft}>ชื่อเล่น</label>
                    {
                      <TextInput
                        id="8"
                        onChange={(e) => {
                          setEmpNickname(e.target.value);
                          setEmpNicknameErr(false);
                        }}
                        error={empNicknameErr}
                        value={empNickname}
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                  <td colspan="3">
                    <label style={marginLeft}>เบอร์โทร</label>
                    {
                      <TextInput
                        id="9"
                        onChange={(e) => {
                          setEmpTel(e.target.value);
                          setEmpTelErr(false);
                        }}
                        error={empTelErr}
                        value={empTel}
                        onKeyDown={handleEnter}
                        type="number"
                        maxLength={10}
                        width="100%"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>กลุ่มสิทธิ์</label>
                    {
                      <SelectAutoComplete
                        id="10"
                        options={roleGroupData}
                        onChange={(value, valueText) => {
                          setRoleGroupName(valueText);
                          setRoleGroupId(value);
                          setRoleGroupErr(false);
                        }}
                        value={roleGroupName}
                        onInputChange={(event, newInputValue) => {}}
                        error={roleGroupErr}
                        width="100%"
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <label style={marginLeft}>สถานะการใช้งาน</label>
                    {
                      <FormGroup style={{ marginLeft: "10px" }}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={statusActive}
                              onChange={() => {
                                setStatusActive(!statusActive);
                              }}
                            />
                          }
                          label={
                            statusActive ? (
                              <label>เปิดการใช้งาน</label>
                            ) : (
                              <label>ปิดการใช้งาน</label>
                            )
                          }
                        />
                      </FormGroup>
                    }
                  </td>
                </tr>
              </table>
            </form>
          </DialogContent>
          <DialogActions>
            <ButtonSave type="submit" />
            <ButtonClose onClick={() => props.onCancel()} />
          </DialogActions>
          <Loading open={loading} />
        </Box>
      </Dialog>
    </>
  );
}

export default AddUserData;
